const unauthorizedNav = [
    'wizard'
];

const webMasterNav = [
    'wizard'
];

const touroperatorNav = [
    'wizard',
    'claims',
    'reports',
    'messages',
    //'postpone'
];

const clientNav = [
    'wizard',
    'myClaims'
];

export {unauthorizedNav, webMasterNav, touroperatorNav, clientNav};